import React, { Component } from 'react';
import axios from 'axios';
import { get, pageContext, replaceBaseUrl, getRulesFromState } from 'ctm-util-functions';
import { connect } from 'react-redux';

import { Ad } from 'ctm-components';
import PropTypes from 'prop-types';

class _CustomAdExperiment extends Component {

    /**
     * Only make bank end service calls when the relevant experiment is running
     */
    componentDidUpdate() {
        const { showExperimentBanner, isExperimentRunning } = this.props;

        if (isExperimentRunning) {
            this.postMarketingsData();

            if (showExperimentBanner) {
                this.postMartechData();
            }
        }
    }

    /**
     * The component should only update when the experiment begins running, triggered
     * by a window function call (triggered by GTM & Optimize)
     * @param {Object} props - the components next props
     * @returns {Boolean} - should component update
     */
    shouldComponentUpdate(props) {
        /*
            We need to check that the experiment isn't already running, if it is we don't want to
            Update again. We also need to check that the mediaType is visible as we only hide the element
            which means the shouldUpdate check is firing for both componenets for xs and not xs
        */
        const { isExperimentRunning, mediaTypeToVisible, mediaType } = this.props;
        return isExperimentRunning !== props.isExperimentRunning
               && mediaTypeToVisible.includes(mediaType);
    }

    /**
     * Post journey id to martech service to keep track of experiment participants, this
     * is used for email marketing.
     */
    postMartechData() {
        const { journeyId, martechTrackingURL } = this.props;
        axios.post(martechTrackingURL, { journeyId })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log(`Posted journeyId: ${journeyId} to experiment endpoint`, response);
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error(`Error posting to experiment endpoint: ${error}`);
            });
    }

    /**
     * Post experiment id to marketings endpoint to track participants of experiment (shown && hidden)
     */
    postMarketingsData() {
        const { marketingsURL, experimentId, accessToken } = this.props;
        axios({
            method: 'post',
            url: marketingsURL,
            data: {
                experimentId
            },
            headers: { Authorization: `Bearer ${accessToken}` }

        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log(`Posted experimentId: ${experimentId} to marketings endpoint`, response);
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error(`Error posting to marketings endpoint: ${error}`);
            });
    }

    /**
     * Returns the Custom ad component
     * @returns {Node} Custom ad component
     */
    render = () =>  {
        const {
            showExperimentBanner,
            desktopImgSrc,
            mobileImgSrc,
            promoTextDescr,
            tacsURL,
            mediaTypeToVisible,
            mediaType
        } = this.props;

        const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();

        return showExperimentBanner && mediaTypeToVisible.includes(mediaType) && (
            <Ad className="ad-main-bottom" id="ad-main-bottom">
                <a href={replaceBaseUrl(tacsURL, baseAssetsPath)} download>
                    <picture>
                        <source srcSet={replaceBaseUrl(desktopImgSrc, baseAssetsPath)} media="(min-width: 728px)" />
                        <img src={replaceBaseUrl(mobileImgSrc, baseAssetsPath)} alt={promoTextDescr} />
                    </picture>
                </a>
            </Ad>
        );
    };

}

_CustomAdExperiment.propTypes = {
    martechTrackingURL: PropTypes.string,
    marketingsURL: PropTypes.string,
    desktopImgSrc: PropTypes.string.isRequired,
    mobileImgSrc: PropTypes.string,
    promoTextDescr: PropTypes.string.isRequired,
    tacsURL: PropTypes.string,
    experimentId: PropTypes.string,
    accessToken: PropTypes.string,
    showExperimentBanner: PropTypes.bool,
    isExperimentRunning: PropTypes.bool,
    journeyId: PropTypes.number,
    mediaTypeToVisible: PropTypes.arrayOf(PropTypes.string),
    mediaType: PropTypes.string
};

_CustomAdExperiment.defaultProps = {
    mediaTypeToVisible: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']
};

/**
 * Prepare necessary props from redux state
 * @param {Object} state - redux state
 * @param {Object} props - component props
 * @returns {{
 *  experimentId: *,
 *  isExperimentRunning: *,
 *  showExperimentBanner: *,
 *  marketingsURL: string,
 *  journeyId: *,
 * accessToken: *}} - mapped props
 */
const mapStateToProps = (state, props) => {
    const pageState = pageContext.getProps().pageState || {};

    const rules = getRulesFromState(state, props);

    const isExperimentRunning = get(rules, 'experiment.result');
    const showExperimentBanner = get(rules, 'visibility.result');

    const experimentId = get(state, 'page.experimentId');
    const journeyId = get(state, 'user.journey.transaction.journeyId');
    const baseUrl = get(pageState, 'serverConfig.journeyServiceBaseUrl');
    const accessToken = get(state, 'user.tokens.access_token');

    const marketingsURL = `${baseUrl}journey/${journeyId}/marketings`;
    const mediaType = state.get('browser').mediaType;

    return {
        experimentId,
        isExperimentRunning,
        showExperimentBanner,
        marketingsURL,
        journeyId,
        accessToken,
        mediaType
    };
};

// Connect the component to the Redux store.
const CustomAdExperiment = connect(mapStateToProps)(_CustomAdExperiment);

export { CustomAdExperiment, _CustomAdExperiment };
